export default __webpack_public_path__ + "static/media/kitchen3-afterC-2048w.7411c357.avif";